export const redirectToSignIn = (oktaAuth, url = window.location.href) => {
  oktaAuth.setOriginalUri(url);
  oktaAuth.signInWithRedirect();
};
